export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14636.1f1d101e.jpg";